<app-single-detail svgIcon="feather:user" label="Client" [value]="wineBottleDetails?.clientName"></app-single-detail>
<app-single-detail
  svgIcon="custom:bottle"
  label="Wine type"
  [value]="wineBottleDetails?.wineTypeName"></app-single-detail>
<app-single-detail
  svgIcon="custom:bottle"
  label="Producer"
  [value]="wineBottleDetails?.producerName"></app-single-detail>
<app-single-detail svgIcon="custom:bottle" label="Variety" [value]="wineBottleDetails?.varietyName"></app-single-detail>
<app-single-detail svgIcon="feather:map" label="Region" [value]="wineBottleDetails?.regionName"></app-single-detail>
<app-single-detail svgIcon="feather:calendar" label="Vintage" [value]="wineBottleDetails?.vintage"></app-single-detail>
